var map = {
	"./Delete.svg": "b0ad",
	"./Edit.svg": "3efa",
	"./active1.svg": "2477",
	"./active2.svg": "bd24",
	"./alert.svg": "659f",
	"./alerts_delete.svg": "5cc5",
	"./arrow-active.svg": "66c9",
	"./arrow.svg": "21e2",
	"./bag-icon.svg": "418c",
	"./calendar.svg": "b8bd",
	"./collapse.svg": "dbb3",
	"./expand.svg": "83364",
	"./failed-icon.svg": "f3a3",
	"./icon-approve-duration.png": "2aee",
	"./icon-calendar.svg": "35f4",
	"./icon-decline-duration.png": "9c97",
	"./icon-leftover-duration.png": "a975",
	"./icon-pending-duration.png": "1896",
	"./icon-total-duration.png": "989d",
	"./icon_export.svg": "7654",
	"./leave-requests.svg": "cd38",
	"./lock.svg": "9619",
	"./pending.svg": "e25a",
	"./requests-img.svg": "8a95",
	"./requests.svg": "1c19",
	"./sick-icon.svg": "8b30",
	"./unlock.svg": "d901",
	"./vac-icon.svg": "58cd",
	"./wait-icon.svg": "084c",
	"./warning-icon.svg": "209f",
	"./warning.svg": "daa9",
	"./warning2.svg": "a910"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";